/* @ngInject */

import { FEATURES, shouldBeEnabled, getTrustedBuildingImageUrl } from '../common';

export default class MainCtrl {
    constructor(
        $q,
        $sce,
        $http,
        $scope,
        $state,
        Utility,
        $window,
        $timeout,
        $location,
        $injector,
        $rootScope,
        $filter,
        LayoutService,
        CommonService,
        BuildingsService,
        NavigationService,
        LocalStorageService,
        AuthorizationService,
        AuthenticationService
    ) {
        this.$q = $q;
        this.$sce = $sce;
        this.$http = $http;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$injector = $injector;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.LayoutService = LayoutService;
        this.CommonService = CommonService;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.LocalStorageService = LocalStorageService;
        this.AuthorizationService = AuthorizationService;
        this.AuthenticationService = AuthenticationService;

        this.init();
        this.activate();
    }

    init() {
        this.isHome = false;
        this.user = undefined;
        this.isMobile = false;
        this.authorized = false;
        this.isNewDesign = true;
        this.currentPage = null;
        this.topMarginClass = '';
        this.showFullMenu = false;
        this.selectedBuildingRef = undefined;
        this.buildingsDataService = undefined;
        this.shouldBeEnabled = shouldBeEnabled;
        this.GetTrustedBuildingImageUrl = this.BuildingsService.getTrustedBuildingImageUrl;
        this.title = 'Welcome to your dashboard!';
        this.isLoadingBuildingFeaturesPromise = null;
        this.loadingIndicator = this.Utility.loadingImage;
        this.largePretorLogo = this.Utility.largePretorLogo;
        this.smallPretorLogo = this.Utility.smallPretorLogo;
        this.isBusy = this.LocalStorageService.retrieve('userProfile')
            ? false
            : true;
        this._registerEventHandling();

        this.LocalStorageService.delete('selectedBuildingRef');

        angular
            .element(window)
            .resize(() => this.$timeout(() => this.checkIsMobile()));
    }
    setTitle(value) {
        if (!value) {
            const selector = '#userBuildings .panel-body a, #userBuildings .panel-body a img, #userBuildings .panel-body a span';
            const $links = angular.element(selector, this.$rootScope.$element);

            $links.each((i, l) => {
                const $l = angular.element(l);
                let selectedBuildingTab = $l.hasClass('active');
                if (selectedBuildingTab) {
                    this.title = $l.context.innerText;
                    return;
                }
            });
        } else {
            this.title = value;
        }
    }

    isOnPage(page) {
        const currentPage = this.$state.current.name;
        return !!page && page === currentPage;
    }

    checkIsMobile() {
        this.$timeout(() => {
            const mobileWidth = 991;
            let isMobileScreen = false;
            const screenWidth = $('body').width();

            if (screenWidth <= mobileWidth) {
                isMobileScreen = true;
            }

            console.log(`The current form factor: ${isMobileScreen ? 'Mobile' : 'Bigger than Mobile'}.`);
            this.$timeout(() => {
                this.isMobile = isMobileScreen;
            });
        });
    }

    showBackgroundPic() {
        const shouldShow = this.$state.current.name === FEATURES.DASHBOARD;
        this.topMarginClass = shouldShow ? '' : 'margin-top-3';
        return shouldShow;
    }

    isActive(path, otherPath) {
        const isActive = otherPath
            ? this.$state.current.name === path ||
            this.$state.current.name === otherPath
            : this.$state.current.name === path;
        return isActive;
    }

    toggleSideBar() {
        this.showFullMenu = !this.showFullMenu;
    }

    linkClicked(evt) {
        debugger;
        const linkText = evt.target.innerText.toLowerCase();
        let url = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/`;
    
        if (linkText === 'logout') {
          this.LocalStorageService.clear("FullSite");
        } 
    
        this.$window.location.href = url;
      }

    gotUser(results) {
        const profile = results && results.length > 0 ? results[1] : results;
        /*start Auth Token selected building ref */
        let url = window.location.search;
        for (let i = 0; i < profile.BuildingProfiles.length; i++) {
            const scheme = profile.BuildingProfiles[i];
            if (url.includes(scheme.SchemeReference)) {
                const {
                    SchemeName: buildingName,
                    SchemeReference: buildingRef
                } = profile.BuildingProfiles[i];
                this.setTitle(buildingName);
                this.selectedBuildingRef = buildingRef;
            }
        }
        /*end Auth Token selected building ref */
        this.user = profile;
        if (profile.UserName) {
            this.isBusy = false;
            this.authorized = true;
            let selectedBuildingRef;
            this.friendlyName = profile.FullName;

            let hasBuidlingProfiles =  !angular.isUndefined(this.user.BuildingProfiles)  && [...this.user.BuildingProfiles].length > 0;

            if (!this.selectedBuildingRef) {
                if (hasBuidlingProfiles) {
                    //if (this.user.BuildingProfiles && c > 0) {
                    const {
                        SchemeName: buildingName,
                        SchemeReference: buildingRef
                    } = this.user.BuildingProfiles[0];
                    this.setTitle(buildingName);
                    this.selectedBuildingRef = buildingRef;
                    //}
                }
            } else {
                selectedBuildingRef = this.LayoutService.getSelectedBuildingReference(
                    this.LocalStorageService.retrieve('selectedBuildingRef')
                );
            }

            if (!hasBuidlingProfiles) {
                let selectedBuildingRefQueryString = this.Utility.QueryString('DBRef');
                if (selectedBuildingRefQueryString) {
                    this.selectedBuildingRef = selectedBuildingRefQueryString.toUpperCase();
                }
                let tempBuildRef = this.selectedBuildingRef;
                this.selectedBuildingRef = tempBuildRef.toUpperCase();

                this.$rootScope.$broadcast('set-selected-scheme-active', this.selectedBuildingRef);
                this.$rootScope.$broadcast('selected-building-changed', this.selectedBuildingRef);
                //this.title = buildingName;
                this.setTitle(buildingName);
            }
            this.loadBuildingFeatures();
            this.$timeout(() => {

                const selector = '#userBuildings .panel-body a, #userBuildings .panel-body a img, #userBuildings .panel-body a span';
                const $links = angular.element(selector, this.$rootScope.$element);

                $links.each((i, l) => {
                    const $l = angular.element(l);
                    let selectedBuildingTab = $l.hasClass('active');
                    if (selectedBuildingTab) {
                        this.setTitle($l.context.innerText);
                        //this.title = $l.context.innerText;
                        return;
                    }
                });
            }, 3000);
        }

        if (this.isHome) {
            this.LayoutService.setSelectedBuildingRef();
        }
    }

    get mappedBuildings() {
        const buildings = this.user.BuildingProfiles;
        const mapped = buildings.map(building => {
            const { SchemeReference: schemeReference } = building;
            const imgUrl = this.GetTrustedBuildingImageUrl(schemeReference);
            return {
                imgUrl,
                ...building,
                isSelected: false
            };
        });

        return mapped;
    }

    async activate() {
        this.$timeout(() => this.checkIsMobile());

        await this.NavigationService.setLocalUserObjects();

        this.buildingsDataService = this.BuildingsService;
        this.user = this.AuthenticationService.currentUser();

        if (this.user) {
            this.refreshUserProfile();

            this.buildingsDataService.init();


            this.loadBuildingFeatures();
            if (
                this.user.BuildingProfiles &&
                this.user.BuildingProfiles.length === 1
            ) {
                const {
                    SchemeName: buildingName,
                    SchemeReference: buildingRef
                } = this.user.BuildingProfiles[0];
                //debugger
                this.setTitle(buildingName);
                //this.title = buildingName;

                this.selectedBuildingRef = buildingRef;

                this.user.BuildingProfiles = this.mappedBuildings;
            }
        } else {
            this.$rootScope.$on('user-logged-in', ($event, results) => {
                this.gotUser(results);
            });
        }

        this.currentPage = this.$state.$current.name;
        this.NavigationService.activate();
    }

    refreshUserProfile() {
        const dateTimeFormat = 'DD MMM YYYY HH:mm A',
            lastLoggedInStr = this.LocalStorageService.retrieve('lastLoggedIn'),
            currentDateTime = moment();

        let lastLoggedIn;

        if (lastLoggedInStr) {
            lastLoggedIn = moment(lastLoggedInStr, dateTimeFormat);
        }
        else {
            if (this.user) {
                lastLoggedIn = moment();
            }
            else {
                lastLoggedIn = moment().add(30, 'minutes');
            }
        }

        if (currentDateTime.isSameOrAfter(lastLoggedIn.add(30, 'minutes'))) {
            this.AuthenticationService.authorize(true).then(
                results => {
                    this.gotUser(results);
                },
                err => {
                    console.error(
                        'Error refreshing the user profile at :' +
                        currentDateTime.format(dateTimeFormat),
                        err
                    );
                }
            );
        }

        this.LocalStorageService.save('lastLoggedIn', currentDateTime.format(dateTimeFormat));
        if (this.isHome) {
            this.LayoutService.setSelectedBuildingRef();
        }
    }

    selectBuilding(event, buildingReference) {
        this.LocalStorageService.save(
            'selectedBuildingRef',
            buildingReference.toUpperCase()
        );
        this.$timeout(async () => {
            this.selectedBuildingRef = buildingReference.toUpperCase();
        });
    }

    loadBuildingFeatures() {
        if(!this.BuildingsService.hasInitted){
            this.BuildingsService.init()
        }

        [...this.BuildingsService.buildingsData.allBuildings].forEach(building => {
            const { SchemeReference } = building;
            this.BuildingsService.getBuildingFeatureSettings(SchemeReference);
        });

    }

    get isOnDesktop() {
        const isDesktop = this.isActive('dashboard');
        return isDesktop;
    }

    _registerEventHandling() {

        this.$rootScope.$on('menu-changed', (evt, { shouldShow }) => {
            this.isHome = shouldShow
                ? shouldShow
                : !!!this.$location.$$url || this.$location.$$url === '/';
            this.LocalStorageService.save('isHome', this.isHome);
        });

        this.$rootScope.$on('change-is-busy', (evt, value) => {
            this.$timeout(() => {
                this.isBusy = value;
            });
        });

        this.$rootScope.$on('busy-processes-changed', ($event, busyProcess) => {
            const { type, body, id } = busyProcess;

            switch (type) {
                case 'mainProcess':
                    const isLoading = body ? true : false;
                    if (!isLoading) {
                        this.isBusy = false;
                    } else {
                        this.isBusy = true;
                    }

                    break;
            }
        });

        this.$scope.$on('side-bar-changed-financial', (evt, shouldShow) => {
            this._triggerMenuClick(shouldShow);
        });

        this.$scope.$on('side-bar-changed', (evt, shouldOpen) => {
            this._handleSideBarChange.call(this, evt, shouldOpen);
        });

        this.$scope.$on('navigate-changed', (evt, path, params) => {
            this.currentPage = path;
            this.$state.go(path, params);
            this.NavigationService.gotoTop();
        });

        this.$scope.$on('hamburger-changed', evt => {
            this.showFullMenu = !this.showFullMenu;
        });

        this.$scope.$on('navigation-onload-changed',
            this._handleInitChangeForPage.bind(this)
        );

        this.$rootScope.$on('navigation-onload-changed',
            this._handleInitChangeForPage.bind(this)
        );

        this.$rootScope.$on('building-reference-changed', ($event, buildingRef) => {
            let savedBuildingRef = this.LocalStorageService.retrieve(
                'selectedBuildingRef'
            );

            savedBuildingRef =
                savedBuildingRef &&
                    typeof savedBuildingRef === 'object' &&
                    'SchemeReference' in savedBuildingRef
                    ? savedBuildingRef.SchemeReference
                    : savedBuildingRef;

            this._handleInitChangeForBuilding.call(
                this,
                buildingRef.toUpperCase(),
                savedBuildingRef.toUpperCase()
            );

        });

        this.$rootScope.$on('accounts-confirm-email', ($evt, data) => {
            const { confirmEmail, confirmToken } = data;
            if (data) {
                this.$state.go(FEATURES.REGISTER, {
                    token: confirmToken,
                    email: confirmEmail
                });
            }
        });

        this.$rootScope.$on('user-logged-out', () => {
            this.$window.location = '/';
        });

        this.$rootScope.$on('user-logged-in', ($event, results) => {
            this.gotUser(results);
        });

        this.$rootScope.$on('user-profile-updated', ($event, updatedUser) => {
            this.user.FullName = updatedUser.FullName;
            this.friendlyName = updatedUser.FullName;
        });

        this.$rootScope.$on('clearance-user-logged-in', () => {
            this.$state.go(FEATURES.CLEARANCE_CAPTURE);
        });

        this.$rootScope.$on('rentals-user-logged-in', () => {
            this.$state.go(FEATURES.RENTALS_CAPTURE);
        });

        this.$rootScope.$on('audits-user-logged-in', () => {
            this.$state.go(FEATURES.AUDITS_CAPTURE);
        });

        this.$rootScope.$on('auditors-user-logged-in', () => {
            this.$state.go(FEATURES.AUDITORS_DASHBOARD);
        });

        this.$scope.$watch('MainVM.selectedBuildingRef',
            (newVal, oldVal) => {
                this._handleInitChangeForBuilding.call(this, newVal, oldVal);
            },
            true
        );

        this.$rootScope.$on('client-navigation-changed', ($event, data) => {
            let shouldShow;
            let { path } = data;

            this.NavigationService.gotoTop();

            this.$timeout(() => {
                if (path && path.length < 4) {
                    shouldShow = true;
                } else {
                    shouldShow = false;
                }
                this.$scope.$broadcast('side-bar-changed', shouldShow, path === 'yes');
            });
        });

        this.$rootScope.$on('set-selected-scheme-active',
            ($event, schemeReference) => {
                const elements = angular
                    .element('#homeMenu .list-group .list-group-item')
                    .toArray();

                elements.map(element => angular.element(element).removeClass('active'));

                const selectedElement = elements.find(element => {
                    const $element = angular.element(element);
                    const schemeRef = $element.data('ref');
                    return schemeRef === schemeReference;
                });

                if (!!selectedElement) {
                    angular.element(selectedElement).addClass('active');
                }
            }
        );
        this.$scope.$on('reload-user-units', (event, data) => {
            this.title = data;
        });
        this.$scope.$on('selected-building-changed', ($event, schemeRef, second) => {
            let isInvalidLogin = angular.isUndefined(this.user) || this.user === null;
            let hasBuidlingProfiles = angular.isUndefined(this.user.BuildingProfiles) || this.user.BuildingProfiles === null;

            if (!isInvalidLogin) {
                if (!second) {
                    const oldSelectedBuildingRef = this.LocalStorageService.retrieve('selectedBuildingRef');
                    if (schemeRef) {
                        schemeRef = schemeRef.toUpperCase();
                        if (oldSelectedBuildingRef !== schemeRef) {
                            this.LocalStorageService.save('selectedBuildingRef', schemeRef);
                            this.selectedBuildingRef = schemeRef;
                            if (!hasBuidlingProfiles) {
                                const selectedBuilding = this.user.BuildingProfiles.find(building => {
                                    const { SchemeReference: buildingReference } = building;
                                    if (buildingReference === schemeRef) {
                                        this.setTitle(building.SchemeName);
                                        return true;
                                    }
                                    return false;
                                });

                                if (selectedBuilding) {
                                    const { SchemeName: schemeName } = selectedBuilding;
                                    this.setTitle(selectedBuilding.SchemeName);
                                }
                                this.$rootScope.$emit('selected-building-changed', schemeRef, second);
                            }
                        }
                    }
                }
            }
        });

        this.$scope.$watch('MainVM.selectedBuildingRef',
            (newVal, oldVal) => {
                this._handleInitChangeForBuilding.call(this, newVal, oldVal);
            },
            true
        );

        this.$scope.$watch('MainVM.isBusy',
            (newVal, oldVal) => {
                if (!newVal) {
                    this.$timeout(() => {
                        this.checkIsMobile();
                    }, 100);
                }
            },
            true
        );
    }

    _handleSideBarChange(evt, shouldOpen, isHome) {
        this.$timeout(() => {
            this.showFullMenu = isHome | shouldOpen || false;

            this._triggerMenuClick(shouldOpen);
        });
    }

    _handleInitChangeForBuilding(newValue, oldValue) {
        const isSame = this.Utility.buildingRefsAreEqual(newValue, oldValue);

        if (!isSame) {
            const selectedBuildingRef = this.LayoutService.getSelectedBuildingReference(
                newValue
            );
            this.selectedBuildingRef = !!selectedBuildingRef
                ? selectedBuildingRef.toUpperCase()
                : newValue.toUpperCase();



            this.LocalStorageService.save('selectedBuildingRef', newValue);
            this.$rootScope.$broadcast('selected-building-changed',
                this.selectedBuildingRef.toUpperCase(),
                null,
                oldValue
            );
        }

        const mappedPath = this.AuthorizationService.mapPath(
            this.$state.current.name
        );

        if (mappedPath) {
            const isAuthorized = this.AuthorizationService.isAuthorized(mappedPath);
            if (!isAuthorized) {
                this.$state.go(this.AuthorizationService.unProtectedRoute);
            }
        }
    }

    _handleInitChangeForPage(event, queryObj) {
        const { selectedTab, date } = queryObj;
        if (selectedTab) {
            const tab = selectedTab.toLowerCase();
            let page;
            switch (tab) {
                case '1':
                    page = FEATURES.PAYMENTS;
                    break;
                case '2':
                    page = FEATURES.PAYMENT_AUTHORISATION;
                    break;
                case '3':
                    page = FEATURES.DOCUMENTS;
                    break;
                case '4':
                    page = FEATURES.FINANCIAL_SUMMARY;
                    break;
                case '6':
                    page = FEATURES.MY_PROFILE;
                    break;
                case '7':
                    let section = this.Utility.QueryString('section');
                    if (!!section) {
                        section = section.toLowerCase();
                    } else {
                        section = 'fire';
                    }
                    page = `${FEATURES.COMPLIANCE}.${section}`;
                    break;
                case '8':
                    page = FEATURES.REGISTER;
                    break;
                case '9':
                    page = FEATURES.CLEARANCE_REQUEST;
                    break;
                case '10':
                    page = FEATURES.UTILITY;
                    break;
                case '11':
                    page = FEATURES.DOCUMENTS_APPROVAL;
                    break;
                default:
                    page = FEATURES.DASHBOARD;
            }

            if (page) {
                this.NavigationService.gotoTop();
                if (!this.user) {
                    this.$scope.$watch('MainVM.user', newValue => {
                        if (newValue) {
                            if (date) {
                                this.$state.go(page, { date: date });
                            } else {
                                this.$state.go(page);
                            }
                        }
                    });
                } else {
                    this.$state.go(page, { date });
                }
            }
            this.currentPage = page;
        }
    }
    
    _triggerMenuClick(shouldShow) {
        const isShowing = this.$state.current.name === FEATURES.DASHBOARD;
        if (isShowing) {
            this.$timeout(() => {
                this.toggleSideBar();
                angular.element(angular.element('burger-menu').get(0)).trigger('click');
            });
        }
    }
}
